import axios from "axios";

export const FIND_URL =
  process.env.REACT_APP_API_BASE_URL + "system-user-childs";
export const FIND_UNASSIGNED_ACCOUNTS_URL =
  process.env.REACT_APP_API_BASE_URL + "system-user-unassign-customer";

export function find(queryParams) {
  return axios.get(`${FIND_URL}`);
}

export function findUnAssignedAccounts(queryParams) {
  return axios.get(`${FIND_UNASSIGNED_ACCOUNTS_URL}`);
}
